module.exports = __webpack_public_path__ + "static/media/star-solid.bea68ee5.svg";